<template>
  <ul class="ws-list">
    <li
      v-for="(item, index) in items"
      :key="index"
    >
      <div class="dot">
        <slot name="bullet">
          <ws-icon
            class="default-icon"
            color="ws-red"
            :size="18"
            name="circle_bullet"
          />
        </slot>
      </div>
      <div class="item">
        <slot
          :index="index"
          :item="item"
        >
          {{ item }}
        </slot>
      </div>
    </li>
  </ul>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {WsIcon} from '@odin/components-vue2';

export default defineComponent({
  name: 'WsList',
  components: {
    WsIcon,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
});
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  margin-bottom: 0;

  li {
    flex: 1 1 auto;
    display: flex;
    align-items: center;

    .default-icon {
      margin: 2px 0 2px 2px;
    }

    .item {
      text-align: left;
      flex: 10000 1 auto;
      margin: 0;
    }
  }

  li + li {
    margin-top: map-get($space-sm, y);
  }
}
</style>
